import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { useServicesSection } from '../../Context/ServiceSectionContext';
import "./Cursor.css"

const Cursor = () => {
    const cursorRef = useRef(null);
    const eyeRef = useRef(null);
    const servicesSectionRef = useServicesSection();

    useEffect(() => {
        const handleMouseMove = (event) => {
            if (!cursorRef.current || !eyeRef.current) return;

            cursorRef.current.classList.add('regular');
            gsap.to(cursorRef.current, {
                x: event.clientX,
                y: event.clientY,
                duration: 0.8,
                ease: 'back.out',
            });

            gsap.to(eyeRef.current, {
                x: event.clientX,
                y: event.clientY,
                duration: 1.45,
                ease: 'power4.out',
            });
        };

        const handleMouseEnter = (dets) => {
            cursorRef.current.classList.remove('regular');
            cursorRef.current.classList.add('services');

            gsap.to(cursorRef.current, {
                scale: 5.0,
                x: dets.clientX,
                y: dets.clientY,
                duration: 1.5,
                ease: "back.out"
            });

            eyeRef.current.classList.add('show');
            gsap.to(eyeRef.current, {
                x: dets.clientX,
                y: dets.clientY,
                duration: 1.5,
                ease: "power4.out",
            });
        };

        const handleMouseLeave = (event) => {
            if (!cursorRef.current || !eyeRef.current) return;

            // Remove 'services' class and add 'regular' class
            cursorRef.current.classList.remove('services');
            cursorRef.current.classList.add('regular');
            eyeRef.current.classList.remove('show');

            gsap.to(cursorRef.current, {
                scale: 1.0,
                x: event.clientX,
                y: event.clientY,
                duration: 1.5,
                ease: 'back.out',
            });
        };

        const servicesSection = servicesSectionRef.current;

        document.documentElement.addEventListener('mousemove', handleMouseMove);
        if (servicesSection) {
            servicesSection.addEventListener('mousemove', handleMouseEnter);
            servicesSection.addEventListener('mouseleave', handleMouseLeave);
        }

        return () => {
            document.documentElement.removeEventListener('mousemove', handleMouseMove);
            if (servicesSection) {
                servicesSection.removeEventListener('mousemove', handleMouseEnter);
                servicesSection.removeEventListener('mouseleave', handleMouseLeave);
            }
        };
    }, []);

    return (
        <>
            <div ref={cursorRef} className="cursor"></div>
            <div ref={eyeRef} className="eye"></div>
        </>
    );
};

export default Cursor;

